module.exports = __webpack_public_path__ + "img/MeerInDerLuft.2416a9bb.jpg";